import { useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import BaseURL from '../Utilities/BaseUrl';
import axios from 'axios';
import {changePassValidation} from '../Utilities/Passwordvalidation';
import {cartContext}from'../Contexts/CartContext';
import { Helmet } from 'react-helmet';
export default function Changepassword() {
  let{setcheck} =useContext(cartContext);
    const [errormesg, seterrormesg] = useState("");
    const [sucessmesg, setsucessmesg] = useState("");
    const [loading, setloading] = useState(true);
    const [disab, setdisab] = useState(true);
    let navigate = useNavigate();
  
    function tranferPass() {
      let ey1 = document.querySelector(".eye1");
      let inp1 = document.querySelector("#password");
      ey1.innerHTML = `<i class="fa-solid fa-eye eyeicon fa-xl cursor-pointer"></i>`;
      inp1.setAttribute("type", Text);
    }
    function tranferRepass() {
    
        let ey1=document.querySelector('.eye2');
        let inp1=document.querySelector('#rePassword');
        ey1.innerHTML=`<i class="fa-solid fa-eye eyeicon fa-xl cursor-pointer"></i>`
        inp1.setAttribute('type',Text);
      }
      function currentPass() {
        let ey1 = document.querySelector(".eye3");
        let inp1 = document.querySelector("#currentPassword");
        ey1.innerHTML = `<i class="fa-solid fa-eye eyeicon fa-xl cursor-pointer"></i>`;
        inp1.setAttribute("type", Text);
      }
    let Formik = useFormik({
      initialValues: {
        currentPassword: "",
        password: "",
        rePassword:''
      },
  validate:changePassValidation,
      onSubmit: (values) => {
        setloading(false);
        setdisab(false);
       let headers={
        token:localStorage.getItem('token')
       };
        axios
          .put(`${BaseURL}users/changeMyPassword`, values,{headers}
          
          )
          .then((data) => {
            if (data.status == 200) {
              
            
              setsucessmesg(data.data.message);
              setTimeout(() => {
               
                navigate("/login");
              }, 1000);
            }
           
          })
          .catch((error) => {
            if (error.response.status == 401)
            {
               seterrormesg(error.response.data.message);
             
               setloading(true)
               setdisab(true)
            }
              
          });
        }
      
      })
      useEffect(() => {
        setcheck(true);
      
       
      }, [])
      
  return <><Helmet>
  <title>changepassword</title>
  
</Helmet>
  
  
 


   
    <div className="container pt-5 pb-5">
        <div className="row">
          <div className="col-12">
      <div className="loginForm">

      {errormesg !=''? 
              <div className="position-fixed top-10 end-80 p-3 mt-5 ">
              <div
                id="liveToast"
                className="toast  show  "
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
              >
                <div className="toast-header position-relative  border-0 bg-danger ">
                  <button
                    type="button"
                    className="btn-close position-absolute end-0 me-2 mt-2 shadow-none"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="toast-body text-center bg-danger pb-3 fw-bold text-white">
                 Error !..  { errormesg}
                </div>
              </div>
            </div>
             : 
              ""
            }

{sucessmesg ? 
              <div className="position-fixed top-10 end-50 p-3 mt-5 bg-sucess">
                <div
                  id="liveToast"
                  className="toast  show  "
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  <div className="toast-header position-relative  border-0 bg-success">
                    <button
                      type="button"
                      className="btn-close position-absolute end-0 me-2 mt-2 shadow-none"
                      data-bs-dismiss="toast"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="toast-body text-center bg-success pb-3 fw-bold text-white">
                    {sucessmesg } your password changed
                  </div>
                </div>
              </div>
             : 
              ""
            }
        <h2 className="mb-5">Change Password Now .....</h2>

        <form onSubmit={Formik.handleSubmit}>
        <label htmlFor="currentPassword">currentPassword :</label>
          <div className="passwordField">
            <input
              onChange={Formik.handleChange}
              onBlur={Formik.handleBlur}
              type="password"
              name="currentPassword"
              id="currentPassword"
              placeholder="Enter Your currentPassword"
              className="form-control mt-2 w-75 mb-4 shadow-none"
              value={Formik.values.currentPassword}
            />{" "}
            <span className="eye3">
              <i
                className="fa-solid fa-eye-slash eyeicon fa-xl cursor-pointer"
                onClick={currentPass}
              ></i>
            </span>
          </div>
          {Formik.errors.currentPassword && Formik.touched.currentPassword ? (
            <div className="alert alert-danger w-75">
              {Formik.errors.currentPassword}
            </div>
          ) : (
            ""
          )}

          <label htmlFor="password">Password :</label>
          <div className="passwordField">
            <input
              onChange={Formik.handleChange}
              onBlur={Formik.handleBlur}
              type="password"
              name="password"
              id="password"
              placeholder="Enter Your password"
              className="form-control mt-2 w-75 mb-4 shadow-none"
              value={Formik.values.password}
            />{" "}
            <span className="eye1">
              <i
                className="fa-solid fa-eye-slash eyeicon fa-xl cursor-pointer"
                onClick={tranferPass}
              ></i>
            </span>
          </div>
          {Formik.errors.password && Formik.touched.password ? (
            <div className="alert alert-danger w-75">
              {Formik.errors.password}
            </div>
          ) : (
            ""
          )}
           
           <label htmlFor="rePassword">rePassword :</label>
                <div className="passwordField">
                <input
                  onChange={Formik.handleChange}
                  onBlur={Formik.handleBlur}
                  type="password"
                  name="rePassword"
                  id="rePassword"
                  placeholder="Confirm Your Password"
                  className="form-control mt-2 w-75 mb-4 shadow-none"
                  value={Formik.values.rePassword}
                /> <span className="eye2"><i className="fa-solid fa-eye-slash eyeicon fa-xl cursor-pointer" onClick={tranferRepass} ></i></span> </div>
                {Formik.errors.rePassword && Formik.touched.rePassword ? (
                  <div className="alert alert-danger w-75">
                    {Formik.errors.rePassword}
                  </div>
                ) : (
                  ""
                )}
          <button
            type="submit"
            className="btn bg-main px-5 py-2 mt-3 text-white"
            disabled={!(Formik.isValid && Formik.dirty && disab)}
          >
            {loading ? (
              <span>Save</span>
            ) : (
              <span
                className="spinner-grow text-white "
                role="status"
                width={10}
              ></span>
            )}
          </button>
        </form>
      </div></div></div></div>
    </>
  

            }
  
 

